/* eslint-disable max-len */
import { IIconProps } from 'src/interfaces/IconProps';

const CheckCircleIcon = ({ width = 12, height = 12, color = '#fff', ...props }: IIconProps) => (
  <svg width={width} height={height} viewBox='0 0 12 12' fill={color} xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6ZM6 1C3.23858 1 1 3.23858 1 6C1 8.76142 3.23858 11 6 11C8.76142 11 11 8.76142 11 6C11 3.23858 8.76142 1 6 1ZM8.35355 4.64645C8.54882 4.84171 8.54882 5.15829 8.35355 5.35355L5.5 8.20711L3.64645 6.35355C3.45118 6.15829 3.45118 5.84171 3.64645 5.64645C3.84171 5.45118 4.15829 5.45118 4.35355 5.64645L5.5 6.79289L7.64645 4.64645C7.84171 4.45118 8.15829 4.45118 8.35355 4.64645Z'
    />
  </svg>
);

export default CheckCircleIcon;
